import { ref } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import { Bilan, BilanRequest, BilanSearchParams } from "@/interfaces/bilan";

import { bilans, clubUUID, paginationLinks } from "@/shared/state";

const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;

export function useBilan() {
  const isRequestBilan = ref(false);
  const errorBilan = ref(false);

  const fetchBilans = async (body: BilanSearchParams) => {
    try {
      isRequestBilan.value = true;
      errorBilan.value = false;

      bilans.data = [];
      paginationLinks.value = 0;

      const response = await authenticatedFetch(
        `${API_URL}bilans/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      if (response) {
        if (body.type === "paginate") {
          bilans.data = response?.data?.data || [];
          paginationLinks.value = response?.data;
          delete paginationLinks.value.data;
        } else {
          bilans.data = response?.data || [];
        }
      }

      isRequestBilan.value = false;
    } catch (e) {
      errorBilan.value = true;
      isRequestBilan.value = false;
    }
  };

  const addBilan = async (body: BilanRequest) => {
    try {
      isRequestBilan.value = true;
      console.log(body);
      const response = await authenticatedFetch(
        `${API_URL}bilans/store/${clubUUID.value}`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );

      if (response?.data) {
        bilans.data.unshift(response.data);
        //location.reload();
      }

      isRequestBilan.value = false;
    } catch (e) {
      errorBilan.value = true;
      isRequestBilan.value = false;
    }
  };

  const editBilan = async (body: BilanRequest) => {
    try {
      isRequestBilan.value = true;

      const response = await authenticatedFetch(
        `${API_URL}bilans/edit/${body.id}/${clubUUID.value}`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );

      if (response?.data) {
        const index = bilans.data.findIndex((b) => b.id === response.data.id);
        if (index !== -1) {
          bilans.data[index] = response.data;
          //location.reload();
        }
      }

      isRequestBilan.value = false;
    } catch (e) {
      errorBilan.value = true;
      isRequestBilan.value = false;
    }
  };

  const deleteBilan = async (id: number) => {
    try {
      isRequestBilan.value = true;

      await authenticatedFetch(
        `${API_URL}bilans/delete/${id}/${clubUUID.value}`,
        { method: "DELETE" },
        true,
        "",
        true,
      );

      const index = bilans.data.findIndex((b) => b.id === id);
      if (index !== -1) {
        bilans.data.splice(index, 1);
      }

      isRequestBilan.value = false;
    } catch (e) {
      errorBilan.value = true;
      isRequestBilan.value = false;
    }
  };

  return {
    fetchBilans,
    addBilan,
    editBilan,
    deleteBilan,
    isRequestBilan,
    errorBilan,
  };
}
